import axios from 'axios';
import qs from 'qs';
import { BaseService } from './base.service';
import { WmsUserDTO } from '../model/WmsUserDTO';
import { WmsUserRequestDTO } from '../model/WmsUserRequestDTO';

export class UserService extends BaseService {
	async getUserInfo(): Promise<WmsUserDTO> {
		return await axios.get<WmsUserDTO>("/api/user/info").then(res => res.data);	// base methods not used to prevent caching and sending useless params langId/timeId
	}

	async postLogin(email: string, password: string) {
		return await this.post("/api/user/login", qs.stringify({ email, password }), { headers: { "Content-Type": "application/x-www-form-urlencoded" } });
	}

	async postLogout() {
		return await this.post("/api/user/logout");
	}

	async postRegisterUser(userRequest: WmsUserRequestDTO) {
		return await this.post("/api/user/register", userRequest);
	}

	async postUserInfo(userRequest: WmsUserRequestDTO) {
		return await this.post("/api/user/info", userRequest);
	}

	async postSaveFavorites() {
		return await this.post("/api/user/save-favorites");
	}
}
